import { QuoteRejectionReasonEnum } from '@/gen/cortado/v1/settings_pb'

const REJECTION_REASON_LABELS: Partial<Record<QuoteRejectionReasonEnum, string>> = {
  [QuoteRejectionReasonEnum.QUOTE_REJECTION_REASON_PRICE_TOO_HIGH]: 'Price too high',
  [QuoteRejectionReasonEnum.QUOTE_REJECTION_REASON_CHOSE_ANOTHER_VENDOR]: 'Chose another vendor',
  [QuoteRejectionReasonEnum.QUOTE_REJECTION_REASON_DATE_OR_PLANS_CHANGED]: 'Date or plans changed',
  [QuoteRejectionReasonEnum.QUOTE_REJECTION_REASON_EVENT_CANCELLED]: 'Event cancelled',
  [QuoteRejectionReasonEnum.QUOTE_REJECTION_REASON_SERVICES_NOT_A_FIT]: 'Services not a fit',
  [QuoteRejectionReasonEnum.QUOTE_REJECTION_REASON_OTHER]: 'Other',
}

/** Tenant-facing label for a decline reason category; empty for UNSPECIFIED. */
export function getQuoteRejectionReasonLabel(category: QuoteRejectionReasonEnum): string {
  return REJECTION_REASON_LABELS[category] ?? ''
}
